import type { AfterViewInit, OnDestroy } from '@angular/core';
import { Directive, ElementRef, NgZone, inject } from '@angular/core';
import { Share } from '@capacitor/share';
import { Pwa } from '@freelancer/pwa';
import { TimeUtils } from '@freelancer/time-utils';
import type { Timer } from '@freelancer/time-utils/testing';

@Directive({
  selector: `[flNativeCopy]`,
  standalone: true,
})
export class NativeCopyDirective implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private ngZone = inject(NgZone);
  private pwa = inject(Pwa);
  private timeUtils = inject(TimeUtils);

  longPressTimer: Timer;
  readonly LONG_PRESS_DELAY = 500;

  private get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  longPressShowShareMenu = (): void => {
    this.longPressTimer = this.timeUtils.setTimeout(async () => {
      await Share.share({
        text: this.element.innerText,
      }).catch(error => {
        // User changes their mind. Ignore the error.
        if (error.message === 'Share canceled') {
          return;
        }
        throw error;
      });
    }, this.LONG_PRESS_DELAY);
  };

  longPressClearTimeout = (): void => {
    clearTimeout(this.longPressTimer);
  };

  ngAfterViewInit(): void {
    if (this.pwa.isNative()) {
      this.ngZone.runOutsideAngular(() => {
        this.element.addEventListener(
          'touchstart',
          this.longPressShowShareMenu,
        );
        this.element.addEventListener('touchend', this.longPressClearTimeout);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.pwa.isNative()) {
      this.ngZone.runOutsideAngular(() => {
        this.element.removeEventListener(
          'touchstart',
          this.longPressShowShareMenu,
        );
        this.element.removeEventListener(
          'touchend',
          this.longPressClearTimeout,
        );
      });
    }
  }
}
